module.exports = __webpack_public_path__ + "static/media/Sale_Post02-Image.07c39b02.jpg";